export type AddToCartPriceResult = {
    PriceID: number;
    TicketID: number;
    IsSuccess: boolean;
    ErrorCode: string;
    ErrorMessage: string;
};
